import Model from './BaseModel';
import Promotion from '@/Models/Promotion.js';
import BonusBet from '@/Models/BonusBet.js';
import AdminUser from '@/Models/AdminUser.js';

export default class PromotionUser extends Model {
	resourceName() {
		return 'promotion_users';
	}

	fields() {
		return ['user_id', 'name', 'used', 'max_bonus_amount', 'created_at'];
	}

	relationships() {
		return {
			promotion: new Promotion(),
			bonus: new BonusBet(),
			adminUser: new AdminUser()
		};
	}
}
